import { inRange } from 'lodash-es';

import type { ViewportEventPosition } from '../types/pointer-events.js';

export const isWithinBounds = (
  position: ViewportEventPosition,
  bounds: Pick<DOMRect, 'top' | 'left' | 'bottom' | 'right'> | undefined,
) => {
  if (!bounds) {
    return false;
  }

  const { top, left, bottom, right } = bounds;
  const { clientX, clientY } = position;

  return inRange(clientX, left, right) && inRange(clientY, top, bottom);
};
